<div *ngIf="_open" class="modal d-flex flex-column justify-content-center">
  <svg
    (click)="clear()"
    class="closer action"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="24" fill="#EEEBE6" />
    <line
      x1="28.3037"
      y1="28.5962"
      x2="18.4042"
      y2="18.6967"
      stroke="#1D1D1D"
    />
    <line
      x1="28.5967"
      y1="18.6967"
      x2="18.6972"
      y2="28.5962"
      stroke="#1D1D1D"
    />
  </svg>
  <div class="inner">
    <h3 class="w-75 mb-4">Select your location and currency</h3>
    <div class="form-floating mb-4">
      <select (change)="selectCountry($event.target)" class="form-select">
        <option [selected]="environment.store === 'AU'" value="AU">
          Australia
        </option>
        <option [selected]="environment.store === 'US'" value="US">
          United States
        </option>
        <option [selected]="environment.store === 'INT'" value="INT">
          Global Store
        </option>
        <!-- todo this should come from the env files  -->
      </select>
      <label for="floatingSelect">Country</label>
    </div>
    <!-- <div class="form-floating">
      <select (change)="selectCurrency($event.target)" class="form-select">
        <option>AUD</option>
        <option>USD</option>
        <option>GBP</option>
      </select>
      <label for="floatingSelect">Currency</label>
    </div>
    <button (click)="submit()" class="mt-5 w-100 btn btn-dark">
      Save Selection
    </button> -->
  </div>
</div>
<div (click)="clear()" class="bg"></div>
